import {
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
    navigateToMotorQuote,
    navigateToPersonalDetails,
    navigateToCarDetails,
    navigateToNextOfKin,
    navigateToPayment,
} from '../../../actions/ugMotorInsurance/routing';
import { getActivePageIndex } from '../../../selectors/ugMotorInsurance/routing';
import { PAGE_INDICES } from '../../../actions/ugMotorInsurance/types';

const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;
export const routingRules = (store, next, action) => {
    if (action.type !== NAVIGATE_NEXT && action.type !== NAVIGATE_PREVIOUS) return next(action);
    const result = next(action);
    const state = store.getState();
    const activePageIndex = getActivePageIndex(state);
    if (action.type === NAVIGATE_NEXT) {
        onNavigateNext(store, state, activePageIndex);
        return result;
    }
    onNavigatePrevious(store, state, activePageIndex);
    return result;
};

const onNavigateNext = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.QOUTE:
            store.dispatch(navigateToPersonalDetails());
            break;
        case PAGE_INDICES.PERSONAL_DETAILS:
            if (gatsbyStack === 'ke') {
                store.dispatch(navigateToCarDetails());
            }
            if (gatsbyStack === 'ug') {
                store.dispatch(navigateToNextOfKin());
            }
            break;
        case PAGE_INDICES.CAR_DETAILS:
            store.dispatch(navigateToPayment());
            break;
        case PAGE_INDICES.NEXT_OF_KIN:
            if (gatsbyStack === 'ke') {
                store.dispatch(navigateToPayment());
            }
            if (gatsbyStack === 'ug') {
                store.dispatch(navigateToCarDetails());
            }
            break;
        default:
            store.dispatch(navigateToMotorQuote());
            break;
    }
};

const onNavigatePrevious = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.PERSONAL_DETAILS:
            store.dispatch(navigateToMotorQuote());
            break;

        case PAGE_INDICES.CAR_DETAILS:
            if (gatsbyStack === 'ke') {
                store.dispatch(navigateToPersonalDetails());
            }
            if (gatsbyStack === 'ug') {
                store.dispatch(navigateToNextOfKin());
            }
            break;
        case PAGE_INDICES.NEXT_OF_KIN:
            if (gatsbyStack === 'ke') {
                store.dispatch(navigateToCarDetails());
            }
            if (gatsbyStack === 'ug') {
                store.dispatch(navigateToPersonalDetails());
            }
            break;
        case PAGE_INDICES.PAYMENT:
            store.dispatch(navigateToCarDetails());
            break;
        default:
            store.dispatch(navigateToMotorQuote());
            break;
    }
};
